
<template>
  <div>
    <v-select
      :items="storeList"
      item-text="store_name"
      item-value="store_id"
      v-model="storeId"
      label="選擇要合作的商家"
      outlined
      dense
    ></v-select>
  </div>
</template>

<script lang="babel" type="text/babel">
export default {
  props: {
    popupConfig: {
      type: Object,
    },
  },
  data: () => ({
    storeId: null,
  }),
  created() {
    this.storeId = this.defaultStoreId
  },
  computed: {
    providerId() {
      return this.$route.params.providerId
    },
    defaultStoreId() {
      return this.$store.getters['member/storeId'];
    },
    storeList() {
      const storeList = window.eagleLodash.cloneDeep(this.$store.getters['member/memberStores'])
      storeList.unshift({
        store_id: null,
        store_name: '申請新商家',
      })
      return storeList
    },
  },
  watch: {
    storeId: {
      immediate: true,
      deep: true,
      handler() {
        this.$emit('updateData', this.storeId)
      },
    }
  },
}
</script>

<style lang="sass" type="text/sass">
.qrcode-code-image
</style>
